/**
 * `payrollWarnings` translations: the read-only information warnings on a payroll period.
 */
export const payrollWarnings = {
  mn: {
    payrollWarnings: {
      title: 'Анхааруулга (мэдээлэл)',
      intro: 'Зөвхөн мэдээлэл: цалинг зогсоохгүй, юуг ч өөрчлөхгүй. Тухайн үеийн бүх хүний дундажтай харьцуулсан, ±25%-иас давсан.',
      none: 'Энэ үед анхааруулга алга.',
      worked_a_lot: {
        field_hours: '{{name}}: хээрийн өдөрт дунджаар {{value}} цаг (дундаж {{average}}) — их ажилласан',
        other_hours: '{{name}}: оффис/бусад өдөрт дунджаар {{value}} цаг (дундаж {{average}}) — их ажилласан',
        days_worked: '{{name}}: {{value}} өдөр ажилласан (дундаж {{average}}) — их ажилласан',
      },
      logged_too_few: {
        field_hours: '{{name}}: хээрийн өдөрт дунджаар {{value}} цаг (дундаж {{average}}) — цаг цөөн бүртгэсэн',
        other_hours: '{{name}}: оффис/бусад өдөрт дунджаар {{value}} цаг (дундаж {{average}}) — цаг цөөн бүртгэсэн',
        days_worked: '{{name}}: {{value}} өдөр ажилласан (дундаж {{average}}) — өдөр цөөн бүртгэсэн',
      },
      rule: {
        office_between_field: '{{name}}: {{day}} оффисын өдөр хоёр хээрийн өдрийн дунд байна — хээрийн өдөр байж магадгүй',
        field_without_transit: '{{name}}: {{day}}-аас эхэлсэн хээрийн өдрүүдийн өмнө ч, дараа ч замын өдөр алга',
      },
    },
  },
  en: {
    payrollWarnings: {
      title: 'Warnings (information)',
      intro: 'Information only: nothing here blocks payroll or changes anything. Compared with everyone in this period; flagged beyond ±25%.',
      none: 'No warnings for this period.',
      worked_a_lot: {
        field_hours: '{{name}}: {{value}} h per field day (average {{average}}) — worked a lot',
        other_hours: '{{name}}: {{value}} h per office/other day (average {{average}}) — worked a lot',
        days_worked: '{{name}}: {{value}} days worked (average {{average}}) — worked a lot',
      },
      logged_too_few: {
        field_hours: '{{name}}: {{value}} h per field day (average {{average}}) — logged too few hours',
        other_hours: '{{name}}: {{value}} h per office/other day (average {{average}}) — logged too few hours',
        days_worked: '{{name}}: {{value}} days worked (average {{average}}) — logged too few days',
      },
      rule: {
        office_between_field: '{{name}}: the office day on {{day}} sits between two field days — likely a field day',
        field_without_transit: '{{name}}: the field days from {{day}} have no transit day before or after them',
      },
    },
  },
  ru: {
    payrollWarnings: {
      title: 'Предупреждения (информация)',
      intro: 'Только информация: ничего здесь не блокирует расчёт и ничего не меняет. Сравнение со всеми за этот период; отмечено отклонение больше ±25%.',
      none: 'За этот период предупреждений нет.',
      worked_a_lot: {
        field_hours: '{{name}}: {{value}} ч за полевой день (в среднем {{average}}) — много работал(а)',
        other_hours: '{{name}}: {{value}} ч за офисный/прочий день (в среднем {{average}}) — много работал(а)',
        days_worked: '{{name}}: {{value}} отработанных дней (в среднем {{average}}) — много работал(а)',
      },
      logged_too_few: {
        field_hours: '{{name}}: {{value}} ч за полевой день (в среднем {{average}}) — записано мало часов',
        other_hours: '{{name}}: {{value}} ч за офисный/прочий день (в среднем {{average}}) — записано мало часов',
        days_worked: '{{name}}: {{value}} отработанных дней (в среднем {{average}}) — записано мало дней',
      },
      rule: {
        office_between_field: '{{name}}: офисный день {{day}} стоит между двумя полевыми — вероятно, полевой день',
        field_without_transit: '{{name}}: у полевых дней с {{day}} нет дня в пути ни до, ни после',
      },
    },
  },
}
